import { FC } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  FormHelperText,
} from '@mui/material';
import { Role } from '../../../../axiosApi/models';
import intl from 'components/i18n/ReactIntlWrapper';
import { sortCollection } from '../../../../common/utils';
import { SORT_TYPES } from '../../../../common/constants';

type RoleSelectProps = {
  handleRoleChange: (event: SelectChangeEvent<string>) => void;
  selectedRole: string | '';
  roles: Role[];
  disabled: boolean;
  errors: any;
};

const RoleSelect: FC<RoleSelectProps> = ({
  handleRoleChange,
  roles,
  selectedRole,
  disabled,
  errors,
}) => {
  const rolesSorted = sortCollection(roles, 'label', SORT_TYPES.ASC);

  return (
    <FormControl fullWidth error={!!errors.idRole} size="small" disabled={disabled}>
      <InputLabel id="role-select-label">
        {`${intl.get('employeeProjectForm.placeholder.role')} *`}
      </InputLabel>
      <Select
        labelId="role-select-label"
        id="idRole"
        name="idRole"
        value={disabled ? '' : selectedRole || ''}
        label={`${intl.get('employeeProjectForm.placeholder.role')} *`}
        onChange={handleRoleChange}
      >
        {rolesSorted?.map((role: any) => (
          <MenuItem key={role?.id} value={role?.id}>
            {intl.get(role.label) || role.name}
          </MenuItem>
        ))}
      </Select>
      {errors.idRole && <FormHelperText>{errors.idRole}</FormHelperText>}
    </FormControl>
  );
};

export default RoleSelect;
